import React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { alpha } from '@mui/material/styles'
import { raisedColor } from './detailSurfaces'

// ADDENDUM 33 (E39) punto 8, extendido a Progreso — EL TITULAR DE UN DESPLIEGUE.
//
// Lo que se comparte es LA FORMA, no los campos, y la distinción es la razón de que este módulo
// exista en vez de un componente con cinco huecos fijos:
//
//   · el despliegue de OPERACIONES se alimenta de N4 + la fila de N3, y enseña OK, rechazadas con
//     su destino, incidencias, máquina y desde cuándo;
//   · el de PROGRESO se alimenta de N10, que trae `done`, `pending`, `actualDurationSeconds`,
//     `inspectionSummary` y `openIncidenceCount` — y NO trae rechazadas, ni dispositivo, ni las
//     fechas por operario.
//
// Un componente con los cinco huecos de Operaciones obligaría a Progreso a dejar tres vacíos, y un
// hueco vacío en un titular afirma que ese dato falta cuando lo que pasa es que esa puerta no lo
// sirve. Cada bloque mapea SU DTO a esta lista; lo común es la jerarquía —una franja elevada, con
// las cifras grandes a la izquierda y el "dónde" a la derecha—, que es lo que el PO pidió cuando
// dijo que la estructura fuera la misma.
//
// ⚠ Presentacional puro: ni `t_` ni acceso a datos. Los rótulos llegan traducidos y los valores ya
// resueltos, igual que `deviationLabel` o `operationStatus` devuelven claves y no frases.

/**
 * @param {Array<{testId: string, label: string, value: *, tone?: 'error'|'warning', icon?: node}>} items
 *   las cifras grandes, en orden de lectura. `tone` tiñe el valor y `icon` lo precede — los dos
 *   OPCIONALES a propósito: un color o un icono que aparece siempre deja de significar algo, que es
 *   la lección del rojo permanente de las rechazadas (addendum 33 punto 1).
 * @param {node} [aside] el bloque de la derecha (dónde y desde cuándo), si el DTO lo puede llenar.
 */
export const ExpansionHeadline = ({ testId = 'expansion-headline', items = [], aside = null }) => (
  <Box
    data-testid={testId}
    sx={(theme) => ({
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 3,
      p: 2,
      borderRadius: 2,
      backgroundColor: raisedColor(theme),
      border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`
    })}
  >
    {items.map((item) => (
      <Box key={item.testId}>
        <Typography
          variant='caption'
          sx={{ display: 'block', fontWeight: 800, letterSpacing: 0.8, textTransform: 'uppercase', color: 'text.secondary' }}
        >
          {item.label}
        </Typography>
        <Stack direction='row' spacing={0.5} alignItems='center'>
          {item.icon}
          <Typography
            data-testid={item.testId}
            sx={{ fontSize: 22, fontWeight: 800, color: item.tone ? `${item.tone}.main` : 'text.primary' }}
          >
            {item.value}
          </Typography>
        </Stack>
      </Box>
    ))}
    {!!aside && (
      <>
        <Box sx={{ flex: 1 }} />
        {aside}
      </>
    )}
  </Box>
)
